var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAvatar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2D3EB01A-6A41-417B-A5FD-77C8B3DD3EA9@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFA8-Style-Guide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Style-Guide---SignLive-Interpreter",
    transform: "translate(-318.000000, -6840.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.-Icon/Avatar",
    transform: "translate(318.000000, 6840.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u21B3Select-Color",
    fill: "#646B74",
    cx: 40,
    cy: 40,
    r: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "1.-Icon/User",
    transform: "translate(4.000000, 4.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5026016,38.6351697 C32.2014836,36.9134189 38.3234074,37.091531 44.0710167,38.2446931 C48.4055337,39.116986 51.75,41.8069363 51.75,46.1615503 L51.75,46.1615503 L51.75,58.3211305 L51.75,58.3211305 L51.7079173,58.3553829 C47.1364084,61.2805326 41.7631135,63 36,63 C30.2346716,63 24.8658065,61.2805326 20.2942976,58.3576664 C20.2787934,58.3439654 20.2632893,58.3348315 20.25,58.3211305 L20.25,58.3211305 L20.25,47.1228993 C20.25,43.1701794 22.8192589,39.747229 26.5026016,38.6351697 Z M23.4646744,24.1471155 C22.1534665,15.3100121 29.4293419,7.80646649 38.0053509,9.15829212 C43.3476375,10.0008997 47.7131627,14.501657 48.5326677,20.0117165 C49.8460906,28.8533869 42.5657854,36.3569325 33.9919913,35.0028234 C28.6497047,34.1579324 24.2819646,29.6548916 23.4646744,24.1471155 Z",
    id: "Icon"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAvatar);
export default __webpack_public_path__ + "static/media/Icon_Avatar.3973e4e011fd847cc54d529a4597012b.svg";
export { ForwardRef as ReactComponent };